import React from 'react';

/**
 * Colores y etiquetas del tablero de seguridad. Un solo lugar para que la
 * tarjeta del viaje, la lista y el mapa digan lo mismo.
 *
 * nivel: 0 verde, 1 amarillo, 2 rojo (ReglasSeguridad en el backend).
 */
export const NIVELES = [
    { nombre: 'Normal', color: '#97C459', borde: '#3B6D11', texto: '#27500A', fondo: '#EAF3DE', icono: 'pi-check-circle' },
    { nombre: 'Atención', color: '#EF9F27', borde: '#BA7517', texto: '#633806', fondo: '#FAEEDA', icono: 'pi-exclamation-circle' },
    { nombre: 'Crítico', color: '#E24B4A', borde: '#A32D2D', texto: '#791F1F', fondo: '#FCEBEB', icono: 'pi-exclamation-triangle' }
];

export const nivelDe = (n) => NIVELES[Math.max(0, Math.min(2, Number(n) || 0))];

/** Color del punto de un evento en el mapa y del borde en la lista. */
export const colorEvento = (e) => {
    if (!e || e.clase === 'OPERACION') return '#B4B2A9';
    const nombre = String(e.evento || e.novedad || e.tipoEvento || '').toUpperCase();
    if ((e.tipoEvento || '').toUpperCase() === 'PARADA' || nombre === 'PARADA') return '#EF9F27';
    return '#E24B4A';
};

/** La etiqueta del semaforo: color, icono y nombre, nunca solo el color. */
export const Semaforo = ({ nivel, compacto = false }) => {
    const n = nivelDe(nivel);
    return (
        <span className="inline-flex align-items-center gap-1 border-round px-2 py-1 text-sm font-semibold"
              style={{ background: n.fondo, color: n.texto, border: `1px solid ${n.borde}` }}>
            <i className={`pi ${n.icono}`} style={{ fontSize: '.85rem' }} />
            {!compacto && n.nombre}
        </span>
    );
};
